/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import sass from "./assessment.module.sass";
import Badge from "components-new/Badge";
import { ReactComponent as ActionMenuIcon } from "images/ActionMenuIcon.svg";
import PortalWrapper from "components-new/PortalWrapper";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { CreateContext } from "pages/StepPages/StepFour/One/Tables/Tables";
import { IAssessmentOfObjectivesTableData } from "pages/StepPages/StepFour/One/Tables/models";
import AssesmentOfObjectivesModal from "pages/StepPages/StepFour/One/Tables/TableNavigate/AssessmentOfObjectivesTable/AssesmentOfObjectivesModal";
import DropMenu from "pages/StepPages/StepFour/One/Tables/TableNavigate/DropMenu";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import { fetchAssessmentOfObjectivesTableData } from "pages/StepPages/StepFour/One/Tables/fetch";
import { useParams } from "react-router-dom";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import parentSass from "pages/StepPages/StepFour/One/Tables/TableNavigate/nav.module.sass";
import { snackWrapper } from "helpers";
import { ChangeActiveTabContext } from "../TableNavigate";
import { ThreatImplementationAssessmentResponse } from "libs/apiClient/data-contracts";
import { organizationAPI } from "libs/apiClient/Organization";

interface IModal {
	data: null | ThreatImplementationAssessmentResponse;
	active: null | "create" | "edit";
}

interface IRow {
	data: { name: string; fields: ThreatImplementationAssessmentResponse[] };
	modal: (obj: { data: ThreatImplementationAssessmentResponse | null; active: "edit" | "create" }) => void;
	index: number;
	remove: (id: number) => void;
}

const Row: React.FC<IRow> = ({ modal, index, remove, data }) => {
	const { openConfirm, confirm } = useContext(CreateContext);
	const { updateTabs } = useContext(ChangeActiveTabContext);
	const [target, setTarget] = useState<HTMLOrSVGElement | undefined>();
	const toggleTarget = (e: React.MouseEvent<HTMLOrSVGElement>) => {
		e.stopPropagation();
		target ? setTarget(undefined) : setTarget(e.currentTarget);
	};

	const removeItem = () => {
		if (confirm) {
			openConfirm();
			return;
		}
		if (target) {
			organizationAPI.objectAssessmentDelete(+target.dataset.id!).then(() => {
				snackWrapper("success", "Запись успешно удалена");
				updateTabs("ASSESSMENT");
				remove(Number(target.dataset.id));
				setTarget(undefined);
			});
		}
	};

	useOutsideAlerter(target, () => setTarget(undefined));
	return (
		<>
			<DropMenu target={target} click={removeItem} />
			<tr
				onClick={() => {
					confirm
						? openConfirm()
						: modal({
								data: {
									type: data.fields[0].type,
									commentIndividual: data.fields[0].commentIndividual,
									individual: data.fields[0].individual,
									accordance: data.name,
									commentLegal: data.fields[0].commentLegal,
									commentState: data.fields[0].commentState,
									legal: data.fields[0].legal,
									state: data.fields[0].state,
									id: data.fields[0].id,
								},
								active: "edit",
						  });
				}}>
				<td>{index}</td>
				<td>{data.fields[0].type}</td>
				<td>
					<div className={sass.status}>
						{data.fields[0].individual !== null ? (
							data.fields[0].individual ? (
								<Badge type={"error"}>Применимо</Badge>
							) : (
								<Badge type={"success"}>Неприменимо</Badge>
							)
						) : (
							<span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />
						)}
						{data.fields[0].commentIndividual && (
							<div>
								<p>Комментарий:</p>
								<p>{data.fields[0].commentIndividual}</p>
							</div>
						)}
					</div>
				</td>
				<td>
					<div className={sass.status}>
						{data.fields[0].legal !== null ? (
							data.fields[0].legal ? (
								<Badge type={"error"}>Применимо</Badge>
							) : (
								<Badge type={"success"}>Неприменимо</Badge>
							)
						) : (
							<span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />
						)}
						{data.fields[0].commentLegal && (
							<div>
								<p>Комментарий:</p>
								<p>{data.fields[0].commentLegal}</p>
							</div>
						)}
					</div>
				</td>
				<td>
					<div className={sass.status}>
						{data.fields[0].state !== null ? (
							data.fields[0].state ? (
								<Badge type={"error"}>Применимо</Badge>
							) : (
								<Badge type={"success"}>Неприменимо</Badge>
							)
						) : (
							<span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />
						)}
						{data.fields[0].commentState && (
							<div>
								<p>Комментарий:</p>
								<p>{data.fields[0].commentState}</p>
							</div>
						)}
					</div>
				</td>
				<td>
					<div>
						<ActionMenuIcon data-id={data.fields[0].id} onClick={toggleTarget} />
					</div>
				</td>
				{/*{data.name && (*/}
				<td rowSpan={data.fields.length}>
					<div>
						<pre>{data.name}</pre>
					</div>
				</td>
				{/*)}*/}
			</tr>
			{/* eslint-disable-next-line array-callback-return */}
			{data.fields.map((item: any, indexRow: number) => {
				if (indexRow > 0) {
					return (
						<SubRow
							key={indexRow}
							data={{ ...item, name: data.name }}
							modal={() =>
								confirm
									? openConfirm()
									: modal({
											data: {
												type: item.type,
												commentIndividual: item.commentIndividual,
												individual: item.individual,
												accordance: data.name,
												commentLegal: item.commentLegal,
												commentState: item.commentState,
												legal: item.legal,
												state: item.state,
												id: item.id,
											},
											active: "edit",
									  })
							}
							index={indexRow + 1}
							remove={remove}
						/>
					);
				}
			})}
		</>
	);
};
const SubRow: React.FC<Omit<IRow, "data"> & { data: IAssessmentOfObjectivesTableData & { name: string } }> = ({
	modal,
	index,
	remove,
	data,
}) => {
	const { openConfirm, confirm } = useContext(CreateContext);
	const { updateTabs } = useContext(ChangeActiveTabContext);
	const [target, setTarget] = useState<HTMLOrSVGElement | undefined>();
	const toggleTarget = (e: React.MouseEvent<HTMLOrSVGElement>) => {
		e.stopPropagation();
		target ? setTarget(undefined) : setTarget(e.currentTarget);
	};

	const removeItem = () => {
		if (confirm) {
			openConfirm();
			return;
		}
		if (target) {
			organizationAPI.objectAssessmentDelete(+target.dataset.id!).then(() => {
				snackWrapper("success", "Запись успешно удалена");
				updateTabs("ASSESSMENT");
				remove(Number(target.dataset.id));
				setTarget(undefined);
			});
		}
	};

	useOutsideAlerter(target, () => setTarget(undefined));
	return (
		<>
			<DropMenu target={target} click={removeItem} />
			<tr
				key={index}
				onClick={() => {
					confirm
						? openConfirm()
						: modal({
								data: {
									...data,
									id: data.id!,
								},
								active: "edit",
						  });
				}}>
				<td>
					<div>{index}</div>
				</td>
				<td>
					<div>{data.type}</div>
				</td>
				<td>
					<div className={sass.status}>
						{data.individual !== null ? (
							data.individual ? (
								<Badge type={"error"}>Применимо</Badge>
							) : (
								<Badge type={"success"}>Неприменимо</Badge>
							)
						) : (
							<span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />
						)}
						{data.commentIndividual && (
							<div>
								<p>Комментарий:</p>
								<p>{data.commentIndividual}</p>
							</div>
						)}
					</div>
				</td>
				<td>
					<div className={sass.status}>
						{data.legal !== null ? (
							data.legal ? (
								<Badge type={"error"}>Применимо</Badge>
							) : (
								<Badge type={"success"}>Неприменимо</Badge>
							)
						) : (
							<span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />
						)}
						{data.commentLegal && (
							<div>
								<p>Комментарий:</p>
								<p>{data.commentLegal}</p>
							</div>
						)}
					</div>
				</td>
				<td>
					<div className={sass.status}>
						{data.state !== null ? (
							data.state ? (
								<Badge type={"error"}>Применимо</Badge>
							) : (
								<Badge type={"success"}>Неприменимо</Badge>
							)
						) : (
							<span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />
						)}
						{data.commentState && (
							<div>
								<p>Комментарий:</p>
								<p>{data.commentState}</p>
							</div>
						)}
					</div>
				</td>
				<td>
					<div>
						<ActionMenuIcon data-id={data.id} onClick={toggleTarget} />
					</div>
				</td>
			</tr>
		</>
	);
};

const AssessmentObjectives = () => {
	const { container, openConfirm, confirm, currentThread, selectFile, checkTables } = useContext(CreateContext);
	const [modal, setModal] = useState<IModal>({ data: null, active: null });
	const [data, setData] = useState<ThreatImplementationAssessmentResponse[]>([]);
	const [load, setLoad] = useState(false);
	const [assessmentInitial, setAssessmentInitial] = useState("");
	const params = useParams();

	useEffect(() => {
		setLoad(true);
		fetchAssessmentOfObjectivesTableData(Number(params.threadId))
			.then((assessment) => {
				if (typeof assessment === "string") {
					setAssessmentInitial(assessment);
					setData([]);
				} else {
					setAssessmentInitial("");
					setData(assessment);
				}
				setLoad(false);
			})
			.catch(() => setLoad(false));
		//eslint-disable-next-line
	}, []);

	const ref = useRef<HTMLInputElement>(null);

	const removeItem = (id: number) => {
		setData([...data].filter((_) => _.id !== id));
	};

	const render = useMemo(() => {
		const temp: { [key: string]: any } = {};
		data.forEach((_) => {
			if (_.accordance) {
				if (temp[_.accordance]) {
					const { accordance, ...rest } = _;
					temp[_.accordance].push(rest);
				} else {
					const { accordance, ...rest } = _;
					temp[_.accordance] = [rest];
				}
			}
		});
		let arrResult: { name: string; fields: { type: string; influence: string; id: number }[] }[] = [];
		let tempKey: any;
		for (tempKey in temp) {
			arrResult.push({
				name: tempKey,
				fields: temp[tempKey],
			});
		}
		return arrResult;
	}, [data]);

	const initial: ThreatImplementationAssessmentResponse = useMemo(() => {
		return {
			id: 0,
			type: "",
			accordance: "",
			state: null,
			commentLegal: "",
			commentIndividual: "",
			legal: null,
			individual: null,
			commentState: "",
		};
	}, []);
	return (
		<div className={sass.wrapper}>
			<AssesmentOfObjectivesModal
				data={data}
				toggle={modal.active}
				active={modal.data}
				options={render}
				close={() => setModal({ data: null, active: null })}
				replace={(list) => setData(list)}
			/>
			{container.current && (
				<PortalWrapper containerRef={container.current}>
					<input
						ref={ref}
						accept={".docx, application/pdf"}
						onChange={(e) => {
							selectFile(e);
						}}
						id={"file"}
						type={"file"}
						disabled={currentThread?.threatStatus === "APPROVED"}
						hidden={true}
					/>
					<Button
						onClick={() => {
							checkTables({
								type: "model",
								ok: () => {
									ref.current?.click();
								},
							});
						}}
						disabled={currentThread?.threatStatus === "APPROVED"}
						variant={BUTTON_VARIANTS.OUTLINED}>
						Загрузить утвержденный документ
					</Button>
					<Button
						variant={BUTTON_VARIANTS.CONTAINED}
						onClick={() => {
							confirm
								? openConfirm()
								: setModal({
										data: {
											...initial,
											accordance: assessmentInitial || (render && render[0]?.name),
										},
										active: "create",
								  });
						}}>
						Добавить информацию
					</Button>
				</PortalWrapper>
			)}
			<div className={sass.sticky}>
				<div className={sass.caption}>
					Таблица 4 – Оценка целей реализации нарушителями угроз безопасности информации
					<br />в зависимости от возможных негативных последствий и видов ущерба от их реализации
				</div>
				<table>
					<thead>
						<tr>
							<th>Номер</th>
							<th>Виды нарушителей</th>
							<th>Нанесение ущерба физическому лицу</th>
							<th>Нанесение ущерба юридическому лицу, индивидуальному предпринимателю</th>
							<th>
								Нанесение ущерба государству в области обеспечения обороны страны, безопасности государства и
								правопорядка, а также в социальной, экономической, политической, экологической сферах деятельности
							</th>
							<th />
							<th>Соответствие целей видам риска (ущерба) и возможным негативным последствиям</th>
						</tr>
					</thead>
				</table>
			</div>
			<div data-comment-false={true} className={sass.scroll_wrapper}>
				{load ? (
					<LoadingIcon width={50} height={50} className={parentSass.loading} />
				) : (
					<div className={sass.scroll}>
						<table>
							<tbody>
								{render.map((_: any, index) => {
									return (
										<Row key={index} data={_} modal={setModal} index={index + 1} remove={(id) => removeItem(id)} />
									);
								})}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</div>
	);
};

export default AssessmentObjectives;

// return (
//     <React.Fragment key={index}>
//         <tr  onClick={() => confirm ? openConfirm() : setModal({data: {
//                 type:_.fields[0].type,
//                 commentIndividual:_.fields[0].commentIndividual,
//                 individual:_.fields[0].individual,
//                 accordance:_.name,
//                 commentLegal:_.fields[0].commentLegal,
//                 commentState:_.fields[0].commentState,
//                 legal:_.fields[0].legal,
//                 state:_.fields[0].state,
//                 id:_.fields[0].id,
//
//             }, active: 'edit'})}>
//             <td>{index + 1}</td>
//             <td>{_.fields[0].type}</td>
//             <td>
//                 <div className={sass.status}>
//                     {_.fields[0].individual ? <Badge type={'error'}>Применимо</Badge>:<Badge type={'success'}>Неприменимо</Badge>}
//                     {_.fields[0].commentIndividual &&
//                         <div>
//                             <p>Комментарий:</p>
//                             <p>{_.fields[0].commentIndividual}</p>
//                         </div>
//                     }
//                 </div>
//             </td>
//             <td>
//                 <div className={sass.status}>
//                     {_.fields[0].individual ? <Badge type={'error'}>Применимо</Badge> :
//                         <Badge type={'success'}>Неприменимо</Badge>}
//                     {_.fields[0].commentIndividual &&
//                         <div>
//                             <p>Комментарий:</p>
//                             <p>{_.fields[0].commentIndividual}</p>
//                         </div>
//                     }
//                 </div>
//             </td>
//             <td>{_.fields[0].state ?<Badge type={'error'}>Применимо</Badge>:<Badge type={'success'}>Неприменимо</Badge>}</td>
//             <td><ActionMenuIcon data-id={_.fields[0].id} onClick={toggleTarget}/></td>
//             <td rowSpan={_.fields.length}>
//                 <pre>{_.name}</pre>
//             </td>
//         </tr>
//         {_.fields.map((item:any, indexRow:number) => {
//             if (indexRow > 0) {
//                 return (
//                     <tr key={indexRow} onClick={() => confirm ? openConfirm() : setModal({data: {
//                             type:item.type,
//                             commentIndividual:item.commentIndividual,
//                             individual:item.individual,
//                             accordance:_.name,
//                             commentLegal:item.commentLegal,
//                             commentState:item.commentState,
//                             legal:item.legal,
//                             state:item.state,
//                             id:item.id,
//
//                         }, active: 'edit'})}>
//                         <td>{indexRow + index + 1}</td>
//                         <td>{item.type}</td>
//                         <td>
//                             <div className={sass.status}>
//                                 {item.individual ? <Badge type={'error'}>Применимо</Badge>:<Badge type={'success'}>Неприменимо</Badge>}
//                                 {item.commentIndividual &&
//                                     <div>
//                                         <p>Комментарий:</p>
//                                         <p>{item.commentIndividual}</p>
//                                     </div>
//                                 }
//                             </div>                                                    </td>
//                         <td>
//                             <div className={sass.status}>
//                                 {item.legal ? <Badge type={'error'}>Применимо</Badge> :
//                                     <Badge type={'success'}>Неприменимо</Badge>}
//                                 {item.commentLegal &&
//                                     <div>
//                                         <p>Комментарий:</p>
//                                         <p>{item.commentIndividual}</p>
//                                     </div>
//                                 }
//                             </div>
//                         </td>
//                         <td><div>{item.state ?<Badge type={'error'}>Применимо</Badge>:<Badge type={'success'}>Неприменимо</Badge>}</div></td>
//                         <td><ActionMenuIcon data-id={item.id} onClick={toggleTarget}/></td>
//                     </tr>
//
//                 );
//             }
//         })}
//     </React.Fragment>
// );
